<template>
    <v-flex xs12>
        <canvas id="common" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'orderCommon',
        props: ['dataCommon'],
        mounted () {
            let ctx = document.getElementById('common').getContext('2d')

            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['Успешные', 'Отменены', 'В процессе'],
                    datasets: [
                        {
                            data: [
                                this.dataCommon.success,
                                this.dataCommon.failure,
                                this.dataCommon.in_progress
                            ],
                            backgroundColor: [
                                '#2B65F0',
                                '#D0021B',
                                '#F5A623',
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'left',
                    },
                    title: {
                        display: true,
                        text: `Общее количество заказов - ${this.dataCommon.all}`
                    }
                }
            })
        }
    }
</script>
